/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { UserGroup } from '../models/user-group';
import { ExpandedUserGroup } from '../models/expanded-user-group';

/**
 * Ui User Group Controller
 */
@Injectable({
  providedIn: 'root',
})
class UiUserGroupControllerService extends __BaseService {
  static readonly getAllGroupUsingGETPath = '/cc-ui/v1/user-groups/';
  static readonly createUserGroupUsingPOSTPath = '/cc-ui/v1/user-groups/';
  static readonly updateUserGroupUsingPUTPath = '/cc-ui/v1/user-groups/';
  static readonly getAllUserGroupsExpandedUsingGETPath =
    '/cc-ui/v1/user-groups/list/groups-expanded';
  static readonly getUserGroupUsingGETPath = '/cc-ui/v1/user-groups/{groupId}';
  static readonly deleteUserGroupUsingDELETEPath =
    '/cc-ui/v1/user-groups/{groupId}';
  static readonly getUserGroupExpandedUsingGETPath =
    '/cc-ui/v1/user-groups/{groupId}/group-expanded';

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * getAllGroup
   * @return OK
   */
  getAllGroupUsingGETResponse(): __Observable<
    __StrictHttpResponse<Array<UserGroup>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/user-groups/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<UserGroup>>;
      }),
    );
  }
  /**
   * getAllGroup
   * @return OK
   */
  getAllGroupUsingGET(): __Observable<Array<UserGroup>> {
    return this.getAllGroupUsingGETResponse().pipe(
      __map((_r) => _r.body as Array<UserGroup>),
    );
  }

  /**
   * createUserGroup
   * @param userGroup userGroup
   * @return OK
   */
  createUserGroupUsingPOSTResponse(
    userGroup: UserGroup,
  ): __Observable<__StrictHttpResponse<UserGroup>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = userGroup;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/user-groups/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UserGroup>;
      }),
    );
  }
  /**
   * createUserGroup
   * @param userGroup userGroup
   * @return OK
   */
  createUserGroupUsingPOST(userGroup: UserGroup): __Observable<UserGroup> {
    return this.createUserGroupUsingPOSTResponse(userGroup).pipe(
      __map((_r) => _r.body as UserGroup),
    );
  }

  /**
   * updateUserGroup
   * @param userGroup userGroup
   * @return OK
   */
  updateUserGroupUsingPUTResponse(
    userGroup: UserGroup,
  ): __Observable<__StrictHttpResponse<UserGroup>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = userGroup;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/cc-ui/v1/user-groups/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UserGroup>;
      }),
    );
  }
  /**
   * updateUserGroup
   * @param userGroup userGroup
   * @return OK
   */
  updateUserGroupUsingPUT(userGroup: UserGroup): __Observable<UserGroup> {
    return this.updateUserGroupUsingPUTResponse(userGroup).pipe(
      __map((_r) => _r.body as UserGroup),
    );
  }

  /**
   * getAllUserGroupsExpanded
   * @return OK
   */
  getAllUserGroupsExpandedUsingGETResponse(): __Observable<
    __StrictHttpResponse<Array<ExpandedUserGroup>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/user-groups/list/groups-expanded`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ExpandedUserGroup>>;
      }),
    );
  }
  /**
   * getAllUserGroupsExpanded
   * @return OK
   */
  getAllUserGroupsExpandedUsingGET(): __Observable<Array<ExpandedUserGroup>> {
    return this.getAllUserGroupsExpandedUsingGETResponse().pipe(
      __map((_r) => _r.body as Array<ExpandedUserGroup>),
    );
  }

  /**
   * getUserGroup
   * @param groupId groupId
   * @return OK
   */
  getUserGroupUsingGETResponse(
    groupId: string,
  ): __Observable<__StrictHttpResponse<UserGroup>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/user-groups/${encodeURIComponent(String(groupId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UserGroup>;
      }),
    );
  }
  /**
   * getUserGroup
   * @param groupId groupId
   * @return OK
   */
  getUserGroupUsingGET(groupId: string): __Observable<UserGroup> {
    return this.getUserGroupUsingGETResponse(groupId).pipe(
      __map((_r) => _r.body as UserGroup),
    );
  }

  /**
   * deleteUserGroup
   * @param groupId groupId
   */
  deleteUserGroupUsingDELETEResponse(
    groupId: string,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl +
        `/cc-ui/v1/user-groups/${encodeURIComponent(String(groupId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * deleteUserGroup
   * @param groupId groupId
   */
  deleteUserGroupUsingDELETE(groupId: string): __Observable<null> {
    return this.deleteUserGroupUsingDELETEResponse(groupId).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * getUserGroupExpanded
   * @param groupId groupId
   * @return OK
   */
  getUserGroupExpandedUsingGETResponse(
    groupId: string,
  ): __Observable<__StrictHttpResponse<ExpandedUserGroup>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/user-groups/${encodeURIComponent(
          String(groupId),
        )}/group-expanded`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ExpandedUserGroup>;
      }),
    );
  }
  /**
   * getUserGroupExpanded
   * @param groupId groupId
   * @return OK
   */
  getUserGroupExpandedUsingGET(
    groupId: string,
  ): __Observable<ExpandedUserGroup> {
    return this.getUserGroupExpandedUsingGETResponse(groupId).pipe(
      __map((_r) => _r.body as ExpandedUserGroup),
    );
  }
}

module UiUserGroupControllerService {}

export { UiUserGroupControllerService };
